export default __webpack_public_path__ + "images/SpeakersPhotos/Carlos Garcia castellano_FOTO.jpg?7cd0d6ec";